<template>
    <div class="war-zone">
        <div class="flex-space-flex-start promote-to-the-war-zone  qualifying-match">
            <div class="flex-space-between arae-group" style="margin:0" v-for="(item, index) in playGgame.fourUpper" :key="index">
                <img class="icon-lable-top" v-if="item.promotion" src="../../assets/images/winterGame/lab-jingji.png" alt="">
                <div class="champion-li" >
                    <template v-if="item.war_zone">
                        <div class="text-line2">{{item.war_zone || ''}}</div>
                        <div class="theater-name">{{item.team_name || ''}}</div>
                      <div>
                        <img src="../../assets/images/winterGame/jb.png" alt="">
                        <span class="num">{{item.score || 0}}</span>
                    </div>
                    </template>
                    <div class="undetermined" v-else>{{ item }}</div>
                </div>
            </div>
        </div>
        <div class="flex-space-between">
            <div class="botton-line"><img class="pic" src="../../assets/images/winterGame/botton-line.png" /></div>
        </div>
       
        <div class="middle-area">
            <div class=" champion">
                <div class="flex-vertically-center champion-li" :class="playGgame.tow.length > 0 && playGgame.tow[0].promotion ? 'active-have1' : 'active-nothing1'">
                    <div v-if="playGgame.tow && playGgame.tow.length > 0 && playGgame.tow[0].team_name">
                    <img class="icon-lable-top" v-if="playGgame.tow[0].promotion" src="../../assets/images/winterGame/lab-guanjun.png" alt="">
                    <img class="icon-num-top" v-if="playGgame.tow[0].promotion" src="../../assets/images/winterGame/num1.png" alt="">
                    <div class="text-line2">{{playGgame.tow[0].war_zone || ''}}</div>
                    <div class="text-line2 theater-name">{{playGgame.tow[0].team_name || ''}}</div>
                    <div></div>
                    <div>
                        <img src="../../assets/images/winterGame/jb.png" alt="">
                        <span class="num">{{playGgame.tow[0].score || 0}}</span>
                    </div>
                   </div>
                   <div class="undetermined" v-else>待定</div>
                </div>
                <div class="vertical-bar"></div>
            </div>
            <div class="qlzq">
                <img src="../../assets/images/winterGame/squirrel-cup.png" alt="">
                <div class="vertical-bar"></div>
            </div>
            <div class="champion">
                <div class="flex-vertically-center champion-li" :class="playGgame.tow.length > 0 && playGgame.tow[1].promotion ? 'active-have2' : 'active-nothing2'">
                   <div v-if="playGgame.tow && playGgame.tow.length > 0 && playGgame.tow[1].team_name">
                    <img class="icon-lable-top" v-if="playGgame.tow[1].promotion" src="../../assets/images/winterGame/lab-yajun.png" alt="">
                    <img class="icon-num-top" v-if="playGgame.tow[1].promotion" src="../../assets/images/winterGame/num2.png" alt="">
                    <div class="text-line2">{{playGgame.tow[1].war_zone || ''}}</div>
                    <div class="text-line2 theater-name">{{playGgame.tow[1].team_name || ''}}</div>
                    <div></div>
                    <div>
                        <img src="../../assets/images/winterGame/jb.png" alt="">
                        <span class="num">{{playGgame.tow[1].score || 0}}</span>
                    </div>
                   </div>
                   <div class="undetermined" v-else>待定</div>
                </div>
            </div>
        </div>
        <div class="flex-space-between">
            <div class="botton-line rotate"><img class="pic" src="../../assets/images/winterGame/botton-line.png" /></div>
        </div>
        <div class="flex-space-flex-start take-the-crown ">
            <div class="flex-space-between arae-group"   v-for="(item, index) in playGgame.fourLower" :key="index">
                <img class="icon-lable-top" v-if="item.promotion" src="../../assets/images/winterGame/lab-jingji.png" alt="">
                <div class="champion-li">
                    <template v-if="item.war_zone">
                        <div class="text-line2">{{item.war_zone || ''}}</div>
                        <div class="theater-name">{{item.team_name || 0}}</div>
                        <div>
                            <img src="../../assets/images/winterGame/jb.png" alt="">
                            <span class="num">{{item.score || 0}}</span>
                        </div>
                    </template>
                    <div class="undetermined" v-else>{{ item }}</div>
                </div>
            </div>
        </div>
       <div class="competition"> 松鼠杯季军争夺赛 </div>
        <div class="flex-space-flex-start promote-to-the-war-zone competition-arae">
            <div class="flex-space-between arae-group" style="margin:0"  :class="item && item.promotion ? 'active-have1' : 'active-nothing1'" v-for="(item, index) in ((playGgame.three && playGgame.three.length > 0) ? playGgame.three : 2) " :key="index">
                <img class="icon-lable-top" v-if="item.promotion" src="../../assets/images/winterGame/lab-jijun.png" alt="">
                <img class="icon-num-top" v-if="item.promotion" src="../../assets/images/winterGame/num3.png" alt="">
                <div class="champion-li">
                    <template v-if="item.war_zone">
                        <div class="text-line2">{{item.war_zone || ''}}</div>
                        <div class="theater-name">{{item.team_name || ''}}</div>
                        <div>
                            <img src="../../assets/images/winterGame/jb.png" alt="">
                            <span class="num">{{item.score || 0}}</span>
                        </div>
                    </template>
                    <div class="undetermined" v-else>待定</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        playGgame: {
            type: Object,
            default: () => {
                fourUpper: [];
                fourLower: [];
                three: [];
                tow: [];
            }
        }
    },
    data() {
        return {}
    },
    mounted(){
        this.$nextTick(() => {
            console.log('playGgame----',this.playGgame)
            this.$set(this.playGgame, 'fourUpper', this.playGgame.fourUpper || [])
            this.$set(this.playGgame, 'fourLower', this.playGgame.fourLower || [])
            this.$set(this.playGgame, 'three', this.playGgame.three || [])
            this.$set(this.playGgame, 'tow', this.playGgame.tow || [])
        })
      
    }
}
</script>
<style lang="less" scoped>
@import '../../assets/style/global.less';
* {box-sizing: border-box}
.war-zone {
    padding-top: 48px;
    padding-bottom: 48px;
    .champion-li,.arae-group{
        position: relative;
        height: 120px;
        .undetermined{
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .icon-lable-top{
            position: absolute;
            top: 0;
            left: 12px;
            display: block;
            width: 74px;
        }
        .icon-num-top{
            position: absolute;
            top: -8px;
            right: 0px;
            display: block;
            width: 70px;
        }
        .theater-name{
            font-size: 26px;
            font-weight: 600;
            color: #96741E;
            padding-top: 2px;
            padding-bottom: 2px;
        }
    }
    .promote-to-the-war-zone {
        margin: 0 -7px;
        &.padding-botton{
            padding-bottom: 64px;
        }
        // column-count: 2;//想要排成的列数
        //     column-gap: 0;
        .arae-group {
            width: calc(50% - 14px);
            min-height: 122px;
            background: pink;
            margin: 0 7px 12px 7px;
            padding: 16px 16px 12px 16px;
            background: linear-gradient(180deg, #E8F0D5 0%, #D7F0D9 100%);
            border-radius: 8px;

            .name {
                width: 50%;
                font-size: 20px;
                font-weight: 400;
                color: #333333;
                min-height: 100px;

                .the-world {
                    text-overflow: ellipsis;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    display: -moz-box;
                    -moz-line-clamp: 2;
                    -moz-box-orient: vertical;
                    overflow-wrap: break-word;
                    word-break: break-all;
                    white-space: normal;
                }

                .trophy {
                    padding-top: 6px;

                    .pic {
                        width: 22px;
                        height: 22px;
                    }

                    .num {
                        font-size: 22px;
                        font-weight: 400;
                        color: #96741E;
                        word-break: break-all;
                        padding-left: 10px;
                    }
                }
            }

            .text {
                text-align: right;
            }

            .vs {
                width: 48px;
                font-size: 32px;
                font-weight: bold;
                color: #96741E;
            }
        }
    }

    .top-line {
        width: calc(50% - 14px);
        &.rotate{
            transform: rotate(180deg);
        }
        .pic {
            display: block;
            width: 164px;
            margin: 0 auto;
        }
    }

    .botton-line {
        width: 100%;

        .pic {
            display: block;
            width: 340px;
            margin: 0 auto;
        }
        &.rotate{
            transform: rotate(180deg);
        }
    }

    .qualifying-match {

        .arae-group {
            width: calc(50% - 14px);
            position: relative;

            &:nth-child(1) {
                background: url(../../assets/images/winterGame/promotion1.png) no-repeat;
                background-size: 100% 100%;

            }

            &:nth-child(2) {
                background: url(../../assets/images/winterGame/promotion2.png) no-repeat;
                background-size: 100% 100%;

            }
            .champion-li{
                font-size: 22px;
                font-weight: 400;
                text-align: center;
                margin: 0 auto;
                .name {
                width: 50%;
                color: #333333;
                min-height: 100px;
                }
                .num{
                    color: #96741E;
                    padding-left: 10px;
                }   
            }
        }
    }
   
    .take-the-crown {
        min-height: 110px;
        .arae-group {
            width: calc(50% - 14px);
            position: relative;
            text-align: center;
            font-size: 20px;
            font-weight: 600;
            color: #333333;
            padding-top: 22px;
            padding-bottom: 10px;
            &:nth-child(1){
                background: url(../../assets/images/winterGame/run-block1.png) no-repeat;
                background-size: 100% 100%;
            }
            &:nth-child(2){
                background: url(../../assets/images/winterGame/run-block2.png) no-repeat;
                background-size: 100% 100%;
            }
            .champion-li{
               margin: 0 auto;
              .num{
                    font-size: 22px;
                    font-weight: 400;
                    color: #96741E;
                    padding-left: 10px;
                }   
            }
           
        }
    }

    .middle-area {
        .champion {
            width: 314px;
            min-height: 110px;
            margin: 0 auto;
            font-size: 20px;
            font-weight: 600;
            color: #333333;
            .champion-li{
                text-align: center;
                background: url(../../assets/images/winterGame/blue-bac.png) no-repeat;
                background-size: 100% 100%;
                padding: 10px 0;
                min-height: 110px;
                &.active-have1{
                    background: url(../../assets/images/winterGame/promotion-guanjun.png) no-repeat;
                    background-size: 100% 100%;
                    color: #002569;
                    .theater-name{
                        color: #002569;
                        font-weight: 700;
                    }
                    .num{
                        color: #002569;
                    }
                }
                &.active-nothing1{
                    background: url(../../assets/images/winterGame/promotion1.png) no-repeat;
                    background-size: 100% 100%;
                }
                &.active-have2{
                    background: url(../../assets/images/winterGame/promotion-yajun.png) no-repeat;
                    background-size: 100% 100%;
                    color: #002569;
                    .theater-name{
                        color: #002569;
                        font-weight: 700;
                    }
                    .num{
                        color: #002569;
                    }
                }
                &.active-nothing2{
                    background: url(../../assets/images/winterGame/run-block1.png) no-repeat;
                    background-size: 100% 100%;
                }
                .num{
                    font-size: 22px;
                    font-weight: 400;
                    color: #96741E;
                    padding-left: 10px;
                }
            }
        }
        .qlzq{
            width: 370px;
            margin: 0 auto;
            img{
                display: block;
                max-width: 100%;
            }
        }
        .vertical-bar{
            width: 2px;
            height: 50px;
            background: #7CABFF;
            margin: 0 auto;
        }
    }
    .competition-arae{
        .arae-group {
            width: calc(50% - 14px);
            position: relative;
            font-size: 20px;
            font-weight: 600;
            color: #333333;
            background: url(../../assets/images/winterGame/blue-bac.png) no-repeat;
            background-size: 100% 100%;
            &.active-have1:nth-child(1){
                background: url(../../assets/images/winterGame/promotion-jijun.png) no-repeat;
                background-size: 100% 100%;
                color: #002569;
                .theater-name{
                    color: #002569;
                    font-weight: 700;
                }
                .num{
                    color: #002569;
                }
            }  
            &.active-nothing1:nth-child(1){
                background: url(../../assets/images/winterGame/promotion2.png) no-repeat;
                background-size: 100% 100%;
            } 
            &.active-have1:nth-child(2){
                background: url(../../assets/images/winterGame/run-block2.png) no-repeat;
                background-size: 100% 100%;
            }  
            &.active-nothing1:nth-child(2){
                background: url(../../assets/images/winterGame/run-block2.png) no-repeat;
                background-size: 100% 100%;
            } 
            .champion-li{
                margin: 0 auto;
                text-align: center;
              .num{
                    font-size: 22px;
                    font-weight: 400;
                    color: #96741E;
                    padding-left: 10px;
                }   
            }
        }
    }
    .competition{
        text-align: center;
        font-size: 40px;
        padding: 64px 0 26px 0;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #1C96FF;
    }
}
</style>